import { render, staticRenderFns } from "./landmarkProphecy.vue?vue&type=template&id=3c61aefc&scoped=true&"
import script from "./landmarkProphecy.vue?vue&type=script&lang=js&"
export * from "./landmarkProphecy.vue?vue&type=script&lang=js&"
import style0 from "./landmarkProphecy.vue?vue&type=style&index=0&id=3c61aefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61aefc",
  null
  
)

export default component.exports